import { memo } from 'react';
import { Text } from '@connect-x-app/hybrid-ui';
import { LicenseAttribution } from '@connect-x-app/shared-domain-models';
import { licenseAttributionTitle } from '@connect-x-app/shared-license-attribution';
import { COLORS } from '@connect-x-app/shared-ui';
import { APP_CONFIG_TEST_IDS } from '@connect-x-app/web-test-ids';

import '../about.scss';

export const LicenseItem = memo(({ group, licenseId, name, url, version }: LicenseAttribution) => {
  const title = licenseAttributionTitle({ group, name, version });

  return (
    <li className="license-item-container">
      <Text color={COLORS.zulu.$10} size="SM" testID={APP_CONFIG_TEST_IDS.about.licenseItem(name)} weight="semiBold">
        {title}
      </Text>
      {licenseId ? (
        <Text color={COLORS.zulu.$09} size="SM">
          {licenseId}
        </Text>
      ) : null}
      {url ? (
        <a href={url} rel="noreferrer" target="_blank">
          <Text color={COLORS.romeo.$10} size="SM" testID={APP_CONFIG_TEST_IDS.about.repository} textDecoration="underline">
            {url}
          </Text>
        </a>
      ) : null}
    </li>
  );
});
